import {format} from 'utils'
import request from 'crm/utils/request'
import api from './api'

export async function setting() {
    return request(api.setting.url)
}

export async function enableSetting(payload) {
    return request(api.enableSetting.url, {
        method: api.enableSetting.type,
        body: payload.body,
    })
}

export async function updateSetting(payload) {
    return request(format(api.updateSetting.url, {message_type: payload.messageType}), {
        method: api.updateSetting.type,
        body: payload.body,
    })
}
